import axios from '@/core/http'

const fetchCountries = () => {
  return axios.get('sources/countries/').then(res => res.data)
}

export { fetchCountries }
